import React, { useEffect, useState } from 'react'
import { Grid, CircularProgress, Container, Paper, useTheme, Typography, Button, Chip, IconButton, useMediaQuery } from '@material-ui/core'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import Rating from '@material-ui/lab/Rating'
import { useParams, useHistory } from 'react-router-dom'
import { getMovieById } from '../../api'
import { useStore } from '../../context/Context'
import useStyles from './styles'

const DetailMovie = () => {
  const { id } = useParams()
  const classes = useStyles()
  const theme = useTheme()
  const history = useHistory()
  const matchSM = useMediaQuery(theme.breakpoints.down('sm'))
  const { isLoading, setIsLoading } = useStore()
  const [data, setData] = useState([])
  const [readmore, setReadmore] = useState(false)

  const toggleReadmore = () => setReadmore(!readmore)

  useEffect(() => {
    const fetchDataById = async (id) => {
      setIsLoading(true)
      try {
        const response = await getMovieById(id)
        setData([response.data])
      } catch (error) {
        console.log(error.message)
      }
      setIsLoading(false)
    }
    fetchDataById(id)
  }, [id, setIsLoading, setData])

  if (isLoading || !data.length) return (
    <Grid container justifyContent="center" alignItems="center" className={classes.loading}>
      <CircularProgress />
    </Grid>
  )

  return (
    <Container>
      <IconButton className={classes.chevron} onClick={() => history.goBack()}>
        <ChevronLeftIcon color="action" />
      </IconButton>
      <Grid container component={Paper} direction={matchSM ? 'column' : 'row'} className={classes.container} elevation={0} wrap={matchSM ? undefined : 'nowrap'}>
        <Grid item md={matchSM ? undefined : 6}>
          <div style={{
            backgroundImage: `url(${data[0].image_url})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            width: '100%',
            height: 483,
            borderRadius: theme.shape.borderRadius
          }} />
        </Grid>
        <Grid item container style={matchSM ? { marginTop: theme.spacing(3) } : { marginLeft: theme.spacing(3) }}>
          <Grid item container direction="column" spacing={1}>
            <Grid item container direction={matchSM ? 'column' : 'row'} alignItems={matchSM ? undefined : 'center'} className={classes.title}>
              <Grid item>
                <Typography variant="h4">{data[0].title}</Typography>
              </Grid>
              <Grid item className={classes.durationContainer}>
                <Typography variant="caption" className={classes.duration}>{data[0].duration} mins</Typography>
              </Grid>
            </Grid>
            <Grid item container alignItems="center">
              <Typography variant="body1" color="textSecondary" className={classes.pushRight}>Rating:</Typography>
              <Rating value={data[0].rating} max={10} size="small" readOnly className={classes.pushRight} />
              <Typography variant="body2" color="textPrimary">{data[0].rating} {data[0].rating > 1 ? 'stars' : 'star'}</Typography>
            </Grid>
            <Grid item container alignItems="center">
              <Typography variant="body1" color="textSecondary" className={classes.pushRight}>Review:</Typography>
              <Typography variant="body2" color="textPrimary" style={{ fontWeight: 500 }}>{data[0].review}</Typography>
            </Grid>
            <Grid item container alignItems="center">
              <Typography variant="body1" color="textSecondary" className={classes.pushRight}>Released in:</Typography>
              <Typography variant="body2" color="textPrimary" style={{ fontWeight: 700 }}>{data[0].year}</Typography>
            </Grid>
            <Grid item container alignItems="center" className={classes.genre}>
              <Typography variant="body1" color="textSecondary" className={classes.pushRight}>Genre:</Typography>
              <div style={{ display: 'inline-flex', gap: '1em', flexWrap: 'wrap' }}>
                {data[0].genre?.split(',').map(genre => genre.trim()).map((genre, index) => (
                  <Chip key={index.toString()} label={genre} style={{ cursor: 'pointer' }} />
                ))}
              </div>
            </Grid>
            <Grid item>
              <Typography variant="body1" color="textSecondary" gutterBottom>Description:</Typography>
              <Typography variant="body2" className={classes.descriptionText} align="justify" gutterBottom>{data[0].description?.length > 300 ? readmore ? data[0].description : data[0].description.slice(0, 300) + ' ...' : data[0].description}</Typography>
              {data[0].description?.length > 300 && <Button size="small" variant="outlined" style={{ textTransform: 'initial', fontSize: 10 }} onClick={toggleReadmore}>{readmore ? 'Readless' : 'Readmore'}</Button>}
            </Grid>
          </Grid>
        </Grid>

      </Grid>
    </Container>
  )
}

export default DetailMovie
